(function () {
  'use strict';

  function syncStickyPrice() {
    const activeOption = document.querySelector(
      '.moonbundle-option-active .moonbundle-option-single-price'
    );

    if (!activeOption) return;

    const priceText = activeOption.textContent.trim();
    if (!priceText) return;

    const stickyPrice = document.querySelector(
      '.sticky-add-to-cart__price .price__regular .price'
    );

    if (!stickyPrice) return;

    stickyPrice.textContent = priceText;
  }

  function syncStickyTitle() {
    const activeOption = document.querySelector(
      '.moonbundle-option-active .moonbundle-option-title'
    );

    if (!activeOption) return;

    const titleText = activeOption.textContent.trim();
    if (!titleText) return;

    // Update the CSS variable so ::after picks it up
    document.querySelector('sticky-add-to-cart')
      ?.style.setProperty('--pack-title', `"${titleText}"`);
  }

  function syncAll() {
    syncStickyPrice();
    syncStickyTitle();
  }

  function initMoonBundleSync() {
    const moonBundle =
      document.querySelector('moonbundle-component') ||
      document.querySelector('.moonbundle-options-horizontal');

    if (!moonBundle) {
      setTimeout(initMoonBundleSync, 500);
      return;
    }

    // Run once on load
    syncAll();

    // Watch for class changes
    const observer = new MutationObserver(function () {
      syncAll();
    });

    observer.observe(moonBundle, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    // Fallback click listener
    document.querySelectorAll('.moonbundle-option-wrapper').forEach(function (el) {
      el.addEventListener('click', function () {
        setTimeout(syncAll, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMoonBundleSync);
  } else {
    initMoonBundleSync();
  }
})();